module.exports = {"master":{"setings":"Settings"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/master.json
// module id = 543
// module chunks = 14